import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';

import { BusinessIntelligenceService } from 'src/app/services/business-intelligence/business-intelligence.service';
import { ManualOrderService } from 'src/app/services/manual-order/manual-order.service';

@Component({
  selector: 'app-handheld',
  templateUrl: './handheld.component.html',
  styleUrls: ['./handheld.component.scss']
})
export class HandheldComponent implements OnInit {

  catalog_nav=[
    {
      'label' : 'Osmo Pocket',
      'link' : 'osmo_pocket',
      'icon' : 'https://www-cdn.djiits.com/dps/7c8319405a3529d93c8fa583fa70a1a6.png'
    },
    {
      'label' : 'Osmo Action',
      'link' : 'osmo_action',
      'icon' : 'https://stag-www-cdn.djiits.com/pre/dps/f6f6675cd3c58ce3683eb16f9f6b0b26.png'
    },
    {
      'label' : 'Osmo Mobile',
      'link' : 'osmo_mobile',
      'icon' : 'https://www-cdn.djiits.com/dps/ef8311c4c307fb42deb65afd23b43269.png'
    },
    {
      'label' : 'DJI Mic',
      'link' : 'dji_mic',
      'icon' : 'https://www-cdn.djiits.com/dps/ea988e584e6816ddae6b6175f97ed51d.png'
    },
    {
      'label' : 'Ronin Cinema',
      'link' : 'dji_ronin',
      'icon' : 'https://www-cdn.djiits.com/dps/5cc2e019595adec2e1b8d1319be88b81.png'
    },
    {
      'label' : 'Ronin Stabilizers',
      'link' : 'dji_stablizer',
      'icon' : 'https://www-cdn.djiits.com/dps/5417cd502563ad2025951f030fb69a99.png'
    },
    {
      'label' : 'DJI Pro Accesories',
      'link' : 'dji_acc',
      'icon' : 'https://www-cdn.djiits.com/dps/b0e6c88f2943a03d8169310748a03085.png'
    },
   
  ]
  selected_item: any;
  active_nav: any;
  products: any;
  params: any;
  type: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService : BusinessIntelligenceService,
    private webService : ManualOrderService,
    private serializer: UrlSerializer,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      console.log('hihi')
      window.scroll({ 
        top: 0, 
        left: 0, 
      
      });



    })


    this.route.queryParamMap.subscribe(queryParams => {
      this.type = queryParams.get("type")
      if(!this.type){
        this.router.navigate(
          [],
          { queryParams: { type:'osmo_pocket'} }
        );
      }

      if(this.type){
        this.params = this.serializer.serialize(this.router.createUrlTree([''],
          { queryParams: this.route.snapshot.queryParams}))   
          this.getProduct()
      }
     
     
    })
  }

  async getProduct(){
  
   
    try {
      
         let response = await this.webService.getProduct(this.params+'&status=1')
      console.log(response)
        this.products = response.data
       
        } catch (e) {
          console.log(e)
        } finally {
           
        }
  }



  navigateTo(item){
    this.router.navigate(
      [],
      { queryParams: { type: item.link } }
    );
    this.active_nav = item
  }

  selectItem(item){
    this.selected_item = item
  }


}
